import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import api from "../../services/api";

/**
 * [FIRST_ACCESS_PASSWORD] Modal bloqueante — abre no primeiro acesso
 * (user.mustChangePassword=true) e obriga trocar senha antes de qualquer outra ação.
 */
const FirstAccessPasswordDialog = ({ open, onLogout }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!currentPassword || !newPassword) return setError("Preencha todos os campos.");
    if (newPassword.length < 6) return setError("A nova senha deve ter no mínimo 6 caracteres.");
    if (newPassword !== confirmPassword) return setError("Confirmação de senha não confere.");
    if (currentPassword === newPassword) return setError("A nova senha deve ser diferente da atual.");
    setLoading(true);
    try {
      await api.put("/users/change-my-password", { currentPassword, newPassword });
      window.location.reload();
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Erro ao trocar senha. Tente novamente.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} disableEscapeKeyDown disableBackdropClick maxWidth="xs" fullWidth>
      <DialogTitle>Trocar senha no primeiro acesso</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Typography variant="body2" style={{ marginBottom: 16 }}>
            Por segurança, você precisa trocar sua senha antes de continuar.
          </Typography>
          {error && (
            <Typography color="error" variant="body2" style={{ marginBottom: 12 }}>
              {error}
            </Typography>
          )}
          <TextField
            autoFocus
            margin="dense"
            label="Senha atual"
            type="password"
            fullWidth
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            disabled={loading}
          />
          <TextField
            margin="dense"
            label="Nova senha (mín. 6 caracteres)"
            type="password"
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            disabled={loading}
          />
          <TextField
            margin="dense"
            label="Confirmar nova senha"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            disabled={loading}
          />
        </DialogContent>
        <DialogActions>
          {onLogout && (
            <Button onClick={onLogout} disabled={loading} color="inherit">
              Sair
            </Button>
          )}
          <Button type="submit" variant="contained" color="primary" disabled={loading}>
            {loading ? <CircularProgress size={20} /> : "Trocar senha"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default FirstAccessPasswordDialog;
